import React from 'react';
import styled, { css } from 'styled-components';

const Wrapper = styled.div<Pick<CalendarEventProps, 'bgColor' | 'hidden'>>`
  ${({ theme }) => theme.typography.cell}
  font-weight: normal;
  background: ${({ bgColor }) => bgColor};
  color: ${({ color }) => color};
  text-align: right;
  width: 100%;
  height: 26px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  margin-top: 4px;
  padding: 0 2px;

  ${({ hidden }) =>
    hidden &&
    css`
      visibility: hidden;

      &[hidden] {
        display: flex;
      }
    `}
`;

const Container = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
`;

export interface CalendarEventProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  bgColor?: string;
  color?: string;
  hidden?: boolean;
}

export function CalendarEvent({
  bgColor,
  color,
  className,
  children,
  hidden,
  ...rest
}: CalendarEventProps) {
  return (
    <Wrapper bgColor={bgColor} className={className} color={color} hidden={hidden} {...rest}>
      <Container>{children}</Container>
    </Wrapper>
  );
}
